import CAPS from "../constants/caps";

const cipaUnidades = [
  'DG - Diretoria Geral',
  'DAF - Diretoria de Administração e Finanças',
  'DAS - Diretoria de Atenção à Saúde',
  'DTEC - Diretoria de Gestão do Trabalho, Ensino e Produção do Conhecimento',
  'DITI - Diretoria de Inovação, Tecnologia e Gestão da Informação',
  'CAPS Herbert de Souza',
  'CAPS AD III Alcenir Veras',
  CAPS.CNES_3708330,
  'CAPS Martha e Dr. Jacinto',
  'Centro de Convivência e Cultura',
  'Consultório na Rua',
  'SRT - São Francisco',
  'SRT - Charitas',
  'SRT - PAC',
  'SRT - PAC V',
  'SRT - Centro',
  'SRT - São Lourenço',
  'MMF Alarico',
  'MMF Atalaia',
  'MMF Badu',
  'MMF Baldeador',
  'MMF Bernardino Raul',
  'MMF Cafubá I',
  'MMF Cafubá II',
  'MMF Cafubá III',
  'MMF Cantagalo',
  'MMF Caramujo',
  'MMF Cavalão',
  'MMF Colônia',
  'MMF Coronel Leôncio',
  'MMF Engenho do Mato',
  'MMF Grota I',
  'MMF Grota II',
  'MMF Holofote',
  'MMF Ilha da Conceição',
  'MMF Ititioca',
  'MMF Jacaré',
  'MMF Jardim das Paineiras',
  'MMF Jonathas Botelho',
  'MMF Jurujuba',
  'MMF Leopoldina',
  'MMF Maceió',
  'MMF Maravista',
  'MMF Marítimos',
  'MMF Martins Torres',
  'MMF Maruí',
  'MMF Matapaca / Maria Paula',
  'MMF Morro da Boa Vista',
  'MMF Morro do Céu',
  'MMF Nova Brasília',
  'MMF Palácio',
  'MMF Ponta Da Areia',
  'MMF Preventório',
  'MMF Sapê',
  'MMF Souza Soares',
  'MMF Teixeira de Freitas',
  'MMF Várzea das Moças',
  'MMF Viçoso Jardim',
  'MMF Vila Ipiranga',
  'MMF Viradouro',
  'MMF Vital Brazil',
  'Unidade de Acolhimento Infantojuvenil',
  'Outro'
];

export default cipaUnidades;
